require("./react-select.css")

const UIModernSelect = require("./index.css")

module.exports = UIModernSelect



// WEBPACK FOOTER //
// ./src/shared/skin/styles/ModernSelect/index.js